import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const LanguageHeader = styled.h5`
  margin-top: 1rem;
  margin-bottom: -0.5rem;
`;

export const PlusIcon = styled.i.attrs({ className: 'fa fa-plus' })``;

export const ImplVersionContainer = styled.div`
  margin-top: 1rem;
  padding-top: 0.5rem;
  border-top: 1px solid ${colors.borderGray};
`;

export const VersionStatus = styled.span`
  ${({ color }) =>
    color &&
    css`
      color: ${color} !important;
    `}
`;
